module.exports = __webpack_public_path__ + "media/images/tokyo_tour_zh01-187cd5d1ec535e78e8494ffae9cbbd85.jpg";